import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';
import { environment } from '../../../environments/environment';

function isUnauthenticatedAuthRequest(url: string): boolean {
  return url.includes('/api/auth/shard/')
    || url.includes('/api/auth/crew/')
    || url.includes('/complete-password-reset');
}

function optionalTenantHeaders(tenantId: string | null | undefined): Record<string, string> {
  const tid = tenantId?.trim();
  return tid ? { 'x-tenant-id': tid } : {};
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const storage = inject(StorageService);
  const storedTenantId = storage.get<string>('tenantId');

  // Auth login / MFA / forgot-password — no Bearer; tenant only when session has one
  if (isUnauthenticatedAuthRequest(req.url)) {
    return next(req.clone({ setHeaders: optionalTenantHeaders(storedTenantId) }));
  }

  // AIO shard API calls (authBaseUrl) — Bearer loginToken + tenant when stored
  if (req.url.startsWith(environment.authBaseUrl)) {
    const loginToken = storage.get<string>('loginToken');
    let cloned = req.clone({ setHeaders: optionalTenantHeaders(storedTenantId) });
    if (loginToken) {
      cloned = cloned.clone({ setHeaders: { Authorization: `Bearer ${loginToken}` } });
    }
    return next(cloned);
  }

  // Relative API calls — login token + tenant when stored
  const loginToken = storage.get<string>('loginToken');
  let cloned = req.clone({ setHeaders: optionalTenantHeaders(storedTenantId) });
  if (loginToken) {
    cloned = cloned.clone({ setHeaders: { Authorization: `Bearer ${loginToken}` } });
  }
  return next(cloned);
};
